<div class="cr02-docs container-fluid width-box">
  <div class="crumb"><a routerLink="/admin/manageuser">Admin</a> / Document Mapping</div>

  <div class="page-head">
    <h1>Document Mapping</h1>
    <label class="control search">
      <i-feather name="search"></i-feather>
      <input
        type="search"
        placeholder="Search supplier name or ID…"
        [ngModel]="searchDraft"
        (ngModelChange)="onSearchChange($event)"
        aria-label="Search suppliers">
    </label>
    <button type="button" class="btn btn-primary" (click)="triggerHeaderUpload()">
      <i-feather name="upload"></i-feather> Upload Sample Invoice
    </button>
    <span class="sub">One row per supplier. Upload a sample invoice, review the extraction, and publish the field mapping to onboard the vendor.</span>
  </div>

  <div class="card">
    <div class="tabs">
      <button
        type="button"
        class="tab"
        *ngFor="let tab of tabs"
        [class.active]="activeTab === tab.key"
        [attr.data-f]="tab.label"
        (click)="setTab(tab.key)">
        {{ tab.label }}
        <span class="count">{{ tabCount(tab.key) | number }}</span>
      </button>
    </div>

    <div class="table-wrap" *ngIf="totalrec; else emptyState">
      <table>
        <thead>
          <tr>
            <th>Supplier</th>
            <th>Mapping Status</th>
            <th>Sample Document</th>
            <th>Attempts</th>
            <th>Last Updated</th>
            <th>Configured By</th>
            <th style="text-align:right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let doc of suppliers">
            <tr class="main">
              <td class="sup">
                <span class="name">{{ doc.supplierName || '—' }}</span>
                <span class="sub">ID {{ doc.supplierId || '—' }}</span>
              </td>

              <td>
                <span class="badge" [ngClass]="getStatusBadgeClass(doc)">{{ getStatusText(doc) }}</span>
                <span class="fail-reason" *ngIf="statusKey(doc) === 'failed' && doc.failureReason">{{ doc.failureReason }}</span>
              </td>

              <td>
                <ng-container *ngIf="doc.documentName; else noDoc">
                  {{ doc.documentName }}
                  <span class="sub">{{ sampleSubLabel(doc) }}</span>
                </ng-container>
                <ng-template #noDoc><span class="sub" style="margin:0">no sample uploaded</span></ng-template>
              </td>

              <td class="att">
                <ng-container *ngIf="doc.attempts && doc.attempts > 0; else noAtt">
                  <ng-container *ngIf="doc.attempts > 1; else oneAtt">
                    {{ doc.attempts }} ·
                    <a (click)="toggleHistory(doc)">{{ isHistoryOpen(doc) ? 'hide' : 'view' }} history</a>
                  </ng-container>
                  <ng-template #oneAtt>1</ng-template>
                </ng-container>
                <ng-template #noAtt>—</ng-template>
              </td>

              <td>
                {{ formatDate(doc.updatedAt || doc.createdAt) }}
                <span class="sub" *ngIf="doc.configuredBy">by {{ doc.configuredBy }}</span>
              </td>

              <td>{{ doc.configuredBy || '—' }}</td>

              <td>
                <div class="row-actions" [ngSwitch]="statusKey(doc)">
                  <!-- Not started -->
                  <button
                    *ngSwitchCase="'not_started'"
                    type="button"
                    class="btn btn-primary btn-icon"
                    title="Upload Sample"
                    aria-label="Upload Sample"
                    (click)="uploadForSupplier(doc)">
                    <i-feather name="upload"></i-feather>
                  </button>

                  <!-- Processing -->
                  <span
                    *ngSwitchCase="'processing'"
                    class="att extracting"
                    title="Extracting…"
                    aria-label="Extracting">
                    <i-feather name="rotate-cw"></i-feather>
                  </span>

                  <!-- Failed -->
                  <ng-container *ngSwitchCase="'failed'">
                    <button
                      type="button"
                      class="btn btn-retry btn-icon"
                      title="Retry Extraction"
                      aria-label="Retry Extraction"
                      (click)="retryExtraction(doc)">
                      <i-feather name="rotate-cw"></i-feather>
                    </button>
                    <button
                      type="button"
                      class="btn btn-ghost btn-icon"
                      title="Upload New Sample"
                      aria-label="Upload New Sample"
                      (click)="uploadForSupplier(doc)">
                      <i-feather name="upload"></i-feather>
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger btn-icon"
                      title="Delete"
                      aria-label="Delete"
                      (click)="deleteMapping(doc)">
                      <i-feather name="trash-2"></i-feather>
                    </button>
                  </ng-container>

                  <!-- Draft -->
                  <ng-container *ngSwitchCase="'draft'">
                    <button
                      type="button"
                      class="btn btn-open btn-sm"
                      (click)="openMapping(doc)">
                      Continue Mapping
                    </button>
                    <button
                      type="button"
                      class="btn btn-ghost btn-icon"
                      *ngIf="hasFile(doc)"
                      title="Download file"
                      aria-label="Download file"
                      (click)="downloadFile(doc)">
                      <i-feather name="download"></i-feather>
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger btn-icon"
                      title="Delete"
                      aria-label="Delete"
                      (click)="deleteMapping(doc)">
                      <i-feather name="trash-2"></i-feather>
                    </button>
                  </ng-container>

                  <!-- Published -->
                  <ng-container *ngSwitchCase="'published'">
                    <button
                      type="button"
                      class="btn btn-open btn-sm"
                      (click)="openMapping(doc)">
                      Open Mapping
                    </button>
                    <button
                      type="button"
                      class="btn btn-ghost btn-icon"
                      *ngIf="hasFile(doc)"
                      title="Download file"
                      aria-label="Download file"
                      (click)="downloadFile(doc)">
                      <i-feather name="download"></i-feather>
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger btn-icon"
                      title="Delete"
                      aria-label="Delete"
                      (click)="deleteMapping(doc)">
                      <i-feather name="trash-2"></i-feather>
                    </button>
                  </ng-container>
                </div>
              </td>
            </tr>

            <tr class="hist" *ngIf="isHistoryOpen(doc)">
              <td colspan="7">
                <div class="hist-box">
                  <div class="hist-loading" *ngIf="isHistoryLoading(doc)">Loading attempt history…</div>
                  <div class="hist-empty" *ngIf="!isHistoryLoading(doc) && attemptsFor(doc).length === 0">No attempt history available.</div>
                  <div class="hist-item" *ngFor="let att of attemptsFor(doc)">
                    <span class="when">{{ formatDate(att.updatedAt || att.createdAt) }}</span>
                    <span class="dotb" [ngClass]="attemptBadgeClass(att.status)">{{ attemptStatusText(att.status) }}</span>
                    <span class="why" *ngIf="att.failureReason">{{ att.failureReason }}</span>
                    <span class="spacer"></span>
                    <ng-container *ngIf="canDeleteAttempt(att)">
                      <a
                        class="hist-link download"
                        title="Download file"
                        aria-label="Download file"
                        (click)="downloadAttempt(att)">
                        <i-feather name="download"></i-feather>
                      </a>
                      <a
                        class="hist-link delete"
                        title="Delete attempt"
                        aria-label="Delete attempt"
                        (click)="deleteAttempt(doc, att)">
                        <i-feather name="trash-2"></i-feather>
                      </a>
                    </ng-container>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="table-foot" *ngIf="totalrec > 0">
      <span class="range">{{ rangeLabel }}</span>
      <label class="rows-per">
        Rows per page
        <select [ngModel]="itemsPerPage" (ngModelChange)="onRowsPerChange($event)">
          <option *ngFor="let n of rowsPerOptions" [ngValue]="n">{{ n }}</option>
        </select>
      </label>
      <nav class="pager" aria-label="Supplier dashboard pagination">
        <button type="button" class="pg" [disabled]="currentPage <= 1" (click)="prevPage()" aria-label="Previous page">‹</button>
        <ng-container *ngFor="let item of pagerItems">
          <span class="pg gap" *ngIf="item === '…'">…</span>
          <button
            type="button"
            class="pg"
            *ngIf="item !== '…'"
            [class.current]="item === currentPage"
            (click)="goToPage(item)">
            {{ item }}
          </button>
        </ng-container>
        <button type="button" class="pg" [disabled]="num_of_pages > 0 && currentPage >= num_of_pages" (click)="nextPage()" aria-label="Next page">›</button>
      </nav>
      <div class="goto">
        <span>Go to page</span>
        <input
          type="number"
          min="1"
          [max]="num_of_pages || 1"
          inputmode="numeric"
          aria-label="Page number"
          [placeholder]="gotoPlaceholder"
          [(ngModel)]="gotoInput"
          (keydown)="onGotoKeydown($event)">
        <button type="button" (click)="submitGotoPage()">Go</button>
        <span class="err" [class.show]="gotoError">Invalid page</span>
      </div>
    </div>
  </div>
</div>

<div class="upload-overlay" *ngIf="uploadOpen" (click)="cancelUpload()">
  <div class="upload-modal" role="dialog" aria-modal="true" aria-labelledby="dmUploadTitle" (click)="$event.stopPropagation()">
    <input
      #fileInput
      type="file"
      accept=".pdf,.xls,.xlsx,.xlsm"
      class="upload-file-input"
      (change)="onFileSelected($event)">

    <ng-container *ngIf="!uploadSuccess; else uploadDone">
      <h3 id="dmUploadTitle">Upload Sample Invoice</h3>
      <p class="upload-lead">Choose a PDF or Excel sample, then start extraction for this supplier.</p>

      <div class="upload-field" *ngIf="!uploadSupplierLocked; else lockedSupplier">
        <label for="dm-supplier-id">Supplier ID</label>
        <input
          id="dm-supplier-id"
          type="text"
          [(ngModel)]="uploadSupplierId"
          placeholder="e.g. 2090"
          [disabled]="uploading"
          autocomplete="off">
      </div>
      <ng-template #lockedSupplier>
        <div class="upload-ctx">
          <b>{{ uploadSupplierName || 'Supplier' }}</b>
          <span>ID {{ uploadSupplierId }}</span>
        </div>
      </ng-template>

      <div class="upload-feedback" *ngIf="uploadError" role="alert">{{ uploadError }}</div>

      <div
        class="dropzone"
        *ngIf="!uploadFile"
        [class.drag]="uploadDragging"
        (click)="browseFiles($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="uploadDragging = false"
        (drop)="onDrop($event)">
        <span class="big">Drop the sample invoice here</span>
        or click to browse · PDF or Excel · max 10 MB
      </div>

      <div class="filecard" *ngIf="uploadFile">
        <i-feather name="file-text"></i-feather>
        <span class="fname">{{ uploadFile.name }}</span>
        <span class="fsize">{{ (uploadFile.size / 1024) | number:'1.0-0' }} KB</span>
        <button type="button" class="rm" [disabled]="uploading" (click)="clearUploadFile()">Remove</button>
      </div>

      <div class="progress" *ngIf="uploading">
        <i [style.width.%]="uploadProgress"></i>
      </div>

      <div class="modal-btns">
        <button type="button" class="mbtn mbtn-ghost" [disabled]="uploading" (click)="cancelUpload()">Cancel</button>
        <button type="button" class="mbtn mbtn-primary" [disabled]="!canSubmitUpload" (click)="submitUpload()">
          Upload &amp; Start Extraction
        </button>
      </div>
    </ng-container>

    <ng-template #uploadDone>
      <div class="up-success">
        <div class="tick">✓</div>
        <h3>Sample uploaded</h3>
        <p>{{ uploadSuccessMessage }}</p>
        <div class="modal-btns" style="justify-content:center">
          <button type="button" class="mbtn mbtn-primary" (click)="finishUpload()">Done</button>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #emptyState>
  <div class="empty-state">
    <div class="empty-title">No suppliers found</div>
    <div class="empty-help">
      <span *ngIf="search_value || activeTab !== 'all'">No suppliers match your filters. Try a different search or tab.</span>
      <span *ngIf="!search_value && activeTab === 'all'">No suppliers available yet.</span>
    </div>
  </div>
</ng-template>
